import React, { useState } from 'react';
import { API_BASE } from '../utils/api';
import { saveAuth } from '../utils/auth';

function UsernameModal({ onComplete }) {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const trimmed = username.trim();
    if (!trimmed) return;
    if (!/^[a-zA-Z0-9_]{3,20}$/.test(trimmed)) {
      setError('3–20 characters: letters, numbers, underscores only');
      return;
    }
    setLoading(true);
    try {
      const resp = await fetch(`${API_BASE}/users/claim`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: trimmed }),
      });
      if (resp.status === 409) {
        setError('That username is already taken. Try another.');
        return;
      }
      if (!resp.ok) {
        setError('Something went wrong. Please try again.');
        return;
      }
      const data = await resp.json();
      saveAuth(data.token, data.username);
      onComplete(data.username);
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-panel">
        <div className="modal-header">
          <h2>Welcome to AeroSuggest</h2>
          <p>Choose a username to join the community. No email or password required.</p>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}
          <div className="form-group">
            <label htmlFor="username-input">Username</label>
            <input
              id="username-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="e.g. aviation_fan"
              maxLength={20}
              disabled={loading}
              autoFocus
            />
            <small>3–20 characters. Letters, numbers, underscores.</small>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading || !username.trim()}>
            {loading ? 'Joining...' : 'Join AeroSuggest'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => onComplete(null)}>
            Continue as guest
          </button>
        </form>
      </div>
    </div>
  );
}

export default UsernameModal;
